<template>
	<div class="msg_box">
		<div></div>
		<div class="schedule_box">
			<div class="schedule_one">
				<span>1</span>我的购物车
			</div>
			<div class="schedule_two">
				<span>2</span>确认订单信息
			</div>
			<div class="schedule_three">
				<span>3</span>成功提交订单
			</div>
		</div>
		<div class="succ">
			<div>订单提交成功！请耐心等待审核</div>
			<div class="laing" @click="xin.goUrl('/product')">再去逛逛</div>
			<div v-if="order_id" class="laing_btn" @click="xin.goUrl('/orderDetails?oid='+order_id)">查看订单</div>
			<div v-else class="laing_btn" @click="xin.goUrl('/personalCenter/orderForm')">查看订单</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				order_id:'',
			}
		},
		created(){
			this.order_id = this.$route.query.order_id;
		},
		methods:{
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.succ{
		width: 400px;
		margin:100px auto;
		text-align: center;
		.laing{
			margin: 30px ;
			font-size: 30px;
		}
		.laing_btn{
			display: inline-block;
			width: 120px;
			height: 40px;
			line-height: 40px;
		}
	}
	.schedule_box {
		.schedule_one {
			background: url(https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/plan_1.png) no-repeat 100% 100%;
			color: #fff;
		}
		.schedule_two {
			background: url(https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/plan_2_1.jpg) no-repeat 100% 100%;
			background-size: 100% 100%;
			color: #fff;
		}
		.schedule_three {
			background: url(https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/plan_3_1.png) no-repeat 100% 100%;
			color: #fff;
		}
	}
</style>
